export default __webpack_public_path__ + "static/media/Slide32.bfdf8c8e.JPG";